import type { Store } from 'redux'
import { initStore } from 'fe-common-app/lib/store'
import { reducer as appReducer } from 'fe-common-app/lib/app'
import { reducer as userReducer } from 'fe-common-app/lib/user'
import type { GlobalState } from 'fe-common-app/lib'
import { reducer as appProductReducer } from 'fe-common-app-state-product'
import type { AppProductState } from 'fe-common-app-state-product'

export type ApplicationState = GlobalState & AppProductState

export const createStore = (): Store<ApplicationState> =>
  initStore<ApplicationState>({
    user: userReducer,
    app: appReducer,
    appProduct: appProductReducer
  })
